import { TUploadRejectReasonCode } from '../components/TradingHistory/UploadButton/UploadButton';

export const translateUploadRejectReason = (
  reasonCode: TUploadRejectReasonCode,
) => {
  switch (reasonCode) {
    case 'ILLEGIBLE':
      return 'Illegible';
    case 'PASSWORD_PROTECTED':
      return 'Password not available';
    case 'MISSING_TRANSACTIONS':
      return 'Missing transactions';
    case 'MISSING_ACCOUNT_DETAILS':
      return 'Missing account details';
    case 'MISSING_BALANCES':
      return 'Missing balances';
    case 'INCOMPLETE_REFERENCES':
      return 'References missing';
    case 'OTHER':
      return 'Other';
    case 'DUPLICATE':
      return 'Duplicate data';
    case 'UNSUPPORTED_EXTENSION':
      return 'Invalid extension';
    case 'UNSUPPORTED_FORMAT':
      return 'Invalid document format';
    case 'NO_RELEVANT_DATA':
      return 'Relevant data not found';
    case 'OUTDATED_INFORMATION':
      return 'Outdated information';
  }
};
